// extracted by mini-css-extract-plugin
module.exports = {"container":"NewOrder_container__mASNV"};